import React, { useState } from 'react';
import Header from 'components/ui/Header';
import Footer from 'components/ui/Footer';
import Icon from 'components/AppIcon';
import { Link } from 'react-router-dom';
import CatalogDownloadModal from 'components/ui/CatalogDownloadModal';

const ProfessionalTrainingServicesPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const catalogUrl = 'https://drive.google.com/file/d/1C3SLPOPkvPjhiw_z7v8xHLfjEJKAsBhO/view';

  const trainingPoles = [
    {
      icon: 'Users',
      title: 'Management des Ressources Humaines',
      description: 'Transformer la fonction RH en un véritable partenaire stratégique de la croissance.',
      modules: [
        'Digitalisation et optimisation des processus RH (HR Tech)',
        'Acquisition, développement et fidélisation des talents',
        'Management social et droit du travail'
      ]
    },
    {
      icon: 'Laptop',
      title: 'Projets Numériques & Innovation',
      description: 'Maîtrisez le marketing digital et la gestion de projets numériques pour propulser votre organisation.',
      modules: [
        'Marketing digital & vente (SEO/SEA, CRM, automatisation)',
        'Gestion de projets numériques',
        'Élaboration d\'un plan marketing digital en 9 étapes'
      ]
    },
    {
      icon: 'Brain',
      title: 'Intelligence Artificielle',
      description: 'Intégrez l\'IA de manière éthique, stratégique et performante dans votre organisation.',
      modules: [
        'Introduction à l\'IA pour décideurs',
        'Outils d\'IA générative pour la productivité',
        'IA appliquée aux RH et au marketing',
        'Chef de projet Intelligence Artificielle (certification)'
      ]
    },
    {
      icon: 'Target',
      title: 'Gestion de Projets & Performance',
      description: 'Pilotez vos projets avec agilité et maximisez la création de valeur.',
      modules: [
        'Méthodes agiles (Scrum, Kanban)',
        'Pilotage de projets d\'IA',
        'Transformation IT et projets numériques',
        'Pilotage de projets par la valeur (ROI)'
      ]
    }
  ];

  const whyChooseUs = [
    {
      icon: 'Briefcase',
      title: 'Expertise Terrain',
      description: 'Nos formateurs sont des consultants actifs, confrontés aux réalités du terrain.'
    },
    {
      icon: 'Settings',
      title: 'Personnalisation',
      description: 'Chaque parcours est conçu sur mesure selon vos enjeux spécifiques.'
    },
    {
      icon: 'TrendingUp',
      title: 'Vision Marché',
      description: 'Nos formations sont alignées sur les compétences réellement recherchées.'
    },
    {
      icon: 'Award',
      title: 'ROI Mesurable',
      description: 'Retour sur investissement mesurable avec suivi personnalisé et accompagnement.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      {/* Section 1: Hero avec Éditorial */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-20 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
                <Icon name="GraduationCap" size={20} style={{ color: '#9B8E57' }} />
                <span className="text-sm font-semibold" style={{ color: '#9B8E57' }}>
                  Catalogue de Formation 2026
                </span>
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Formations Professionnelles
              </h1>
              
              <p className="text-xl md:text-2xl font-semibold" style={{ color: '#9B8E57' }}>
                L'indispensabilité des compétences pour bâtir l'avenir
              </p>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <h3 className="text-lg font-bold mb-3" style={{ color: '#9B8E57' }}>ÉDITORIAL - Dr Oloutayo William Odah</h3>
                <p className="text-gray-300 leading-relaxed mb-4">
                  <strong>2026 : Le futur du travail ne s'attend pas, il se bâtit.</strong>
                </p>
                <p className="text-gray-300 leading-relaxed mb-4">
                  Le monde du travail connaît une mutation sans précédent. En 2026, l'agilité organisationnelle, 
                  la maîtrise des technologies émergentes et l'intelligence émotionnelle ne seront plus des avantages 
                  concurrentiels, mais des exigences fondamentales.
                </p>
                <p className="text-gray-300 leading-relaxed">
                  Chez CRF Perfection, nous portons une conviction forte : <strong>le capital humain est le premier 
                  levier de création de valeur.</strong> Ce catalogue 2026 constitue une feuille de route stratégique, 
                  conçue pour transformer durablement vos équipes, vos managers et vos organisations.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                <Link 
                  to="/contact"
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                  style={{ 
                    backgroundColor: '#96121D',
                    boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#7d0f18';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#96121D';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Demander un Devis
                  <Icon name="ArrowRight" size={20} className="ml-2" />
                </Link>
                
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold rounded-lg border-2 transition-all duration-300"
                  style={{ 
                    borderColor: '#9B8E57',
                    color: '#9B8E57'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#9B8E57';
                    e.target.style.color = '#ffffff';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.color = '#9B8E57';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Télécharger le Catalogue
                  <Icon name="Download" size={20} className="ml-2" />
                </button>
              </div>
            </div>

            {/* Right Content - Stats Cards */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="Users" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">500+</div>
                <div className="text-gray-300 text-sm">Professionnels Formés</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="Award" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">95%</div>
                <div className="text-gray-300 text-sm">Taux de Satisfaction</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(155, 142, 87, 0.2)' }}>
                    <Icon name="Globe" size={24} style={{ color: '#9B8E57' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">International</div>
                <div className="text-gray-300 text-sm">USA & Afrique de l'Ouest</div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="flex items-center space-x-3 mb-3">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                       style={{ backgroundColor: 'rgba(150, 18, 29, 0.2)' }}>
                    <Icon name="BookOpen" size={24} style={{ color: '#96121D' }} />
                  </div>
                </div>
                <div className="text-3xl font-bold mb-1">4 Pôles</div>
                <div className="text-gray-300 text-sm">Domaines de Formation</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section 2: Pôles de Formation */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Nos Pôles de Formation Professionnelle
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des programmes structurés, orientés résultats, conçus pour renforcer durablement les compétences clés
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {trainingPoles?.map((pole, index) => (
              <div 
                key={index}
                className="group bg-gray-50 rounded-2xl p-8 transition-all duration-300 hover:shadow-xl border-2 border-transparent"
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = index % 2 === 0 ? '#96121D' : '#9B8E57';
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div className="flex items-start space-x-4 mb-6">
                  <div 
                    className="w-16 h-16 rounded-xl flex items-center justify-center flex-shrink-0 transition-transform duration-300 group-hover:scale-110"
                    style={{ 
                      backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                    }}
                  >
                    <Icon 
                      name={pole?.icon} 
                      size={32} 
                      style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                    />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">
                      {pole?.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {pole?.description}
                    </p>
                  </div>
                </div>

                <div className="space-y-3">
                  {pole?.modules?.map((module, idx) => (
                    <div key={idx} className="flex items-start space-x-3">
                      <Icon 
                        name="CheckCircle" 
                        size={20} 
                        style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                        className="flex-shrink-0 mt-1"
                      />
                      <span className="text-gray-700">{module}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* L'ère de l'hybridation des compétences */}
          <div className="mt-16 bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 md:p-12 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-6" style={{ color: '#9B8E57' }}>
              L'ère de l'hybridation des compétences
            </h3>
            <p className="text-lg text-gray-300 leading-relaxed mb-6">
              Les profils recherchés en 2026 sont hybrides. Les compétences techniques (hard skills) doivent 
              impérativement se conjuguer aux compétences comportementales (soft skills).
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="flex items-start space-x-3 mb-3">
                  <Icon name="Cpu" size={28} style={{ color: '#9B8E57' }} className="flex-shrink-0" />
                  <div>
                    <h4 className="text-xl font-bold mb-2">Le virage numérique et l'IA</h4>
                    <p className="text-gray-300">
                      Nos programmes en projets numériques, data et IA sont pensés pour vous permettre de piloter 
                      la transformation digitale de manière éthique, stratégique et performante.
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <div className="flex items-start space-x-3 mb-3">
                  <Icon name="Users" size={28} style={{ color: '#96121D' }} className="flex-shrink-0" />
                  <div>
                    <h4 className="text-xl font-bold mb-2">Le leadership cérébral</h4>
                    <p className="text-gray-300">
                      Le manager de demain est un leader-coach, capable de gérer la complexité, l'incertitude 
                      et des équipes hybrides.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section 3: Pourquoi Choisir CRF Perfection */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Pourquoi Choisir CRF Perfection ?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Plus qu'un cabinet, un partenaire de croissance
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
            {whyChooseUs?.map((benefit, index) => (
              <div 
                key={index}
                className="bg-white rounded-xl p-8 text-center transition-all duration-300 hover:shadow-xl"
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div 
                  className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
                  style={{ 
                    backgroundColor: index % 2 === 0 ? 'rgba(150, 18, 29, 0.1)' : 'rgba(155, 142, 87, 0.1)'
                  }}
                >
                  <Icon 
                    name={benefit?.icon} 
                    size={36} 
                    style={{ color: index % 2 === 0 ? '#96121D' : '#9B8E57' }} 
                  />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {benefit?.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {benefit?.description}
                </p>
              </div>
            ))}
          </div>

          {/* Programmes Spéciaux 2026 */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-transparent hover:border-[#96121D] transition-all duration-300">
              <div className="flex items-start space-x-4 mb-4">
                <div className="w-16 h-16 rounded-xl bg-[#96121D]/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Ship" size={32} style={{ color: '#96121D' }} />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    Conférence des Ports Africains (COPAF)
                  </h3>
                  <p className="text-gray-600">
                    Événement international dédié à la transformation digitale, à l'IA et à la performance des ports africains.
                  </p>
                </div>
              </div>
              <div className="space-y-2 mt-6">
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={18} style={{ color: '#96121D' }} />
                  <span className="text-gray-700">Digitalisation portuaire</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={18} style={{ color: '#96121D' }} />
                  <span className="text-gray-700">IA et IoT appliqués aux ports</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={18} style={{ color: '#96121D' }} />
                  <span className="text-gray-700">Marketing portuaire</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={18} style={{ color: '#96121D' }} />
                  <span className="text-gray-700">Cybersécurité des infrastructures</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-transparent hover:border-[#9B8E57] transition-all duration-300">
              <div className="flex items-start space-x-4 mb-4">
                <div className="w-16 h-16 rounded-xl bg-[#9B8E57]/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Heart" size={32} style={{ color: '#9B8E57' }} />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    Programme Business Thérapie
                  </h3>
                  <p className="text-gray-600">
                    Ateliers stratégiques dédiés à la performance, au leadership et à la transformation organisationnelle.
                  </p>
                </div>
              </div>
              <div className="space-y-2 mt-6">
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={18} style={{ color: '#9B8E57' }} />
                  <span className="text-gray-700">Performance organisationnelle</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={18} style={{ color: '#9B8E57' }} />
                  <span className="text-gray-700">Leadership transformationnel</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={18} style={{ color: '#9B8E57' }} />
                  <span className="text-gray-700">Stratégie d'entreprise</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="CheckCircle" size={18} style={{ color: '#9B8E57' }} />
                  <span className="text-gray-700">Accompagnement sur-mesure</span>
                </div>
              </div>
            </div>
          </div>

          {/* Public Cible */}
          <div className="mt-16 bg-white rounded-2xl p-8 md:p-12 shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              Public Cible
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 rounded-full bg-[#96121D]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Users" size={32} style={{ color: '#96121D' }} />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Employés</h4>
                <p className="text-sm text-gray-600">Développement des compétences opérationnelles</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 rounded-full bg-[#9B8E57]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Briefcase" size={32} style={{ color: '#9B8E57' }} />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Cadres</h4>
                <p className="text-sm text-gray-600">Renforcement managérial et leadership</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 rounded-full bg-[#96121D]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Crown" size={32} style={{ color: '#96121D' }} />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Dirigeants</h4>
                <p className="text-sm text-gray-600">Vision stratégique et transformation</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 rounded-full bg-[#9B8E57]/10 flex items-center justify-center mx-auto mb-4">
                  <Icon name="Target" size={32} style={{ color: '#9B8E57' }} />
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Équipes Projets</h4>
                <p className="text-sm text-gray-600">Méthodologies agiles et collaboration</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Section 4: CTA Section avec Footer Complet */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `
              linear-gradient(rgba(155, 142, 87, 0.3) 1px, transparent 1px),
              linear-gradient(90deg, rgba(155, 142, 87, 0.3) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px'
          }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Ensemble, bâtissons les compétences qui feront la différence en 2026
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Investissez dans l'humain, récoltez la performance
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="Phone" size={32} className="mx-auto mb-4" style={{ color: '#9B8E57' }} />
              <h3 className="text-xl font-bold mb-2">Consultation Gratuite</h3>
              <p className="text-gray-300 mb-4">Discutons de vos besoins en formation</p>
              <Link 
                to="/contact"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#9B8E57' }}
              >
                Prendre rendez-vous <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="FileText" size={32} className="mx-auto mb-4" style={{ color: '#96121D' }} />
              <h3 className="text-xl font-bold mb-2">Catalogue Formations</h3>
              <p className="text-gray-300 mb-4">Explorez tous nos programmes</p>
              <button
                onClick={() => setIsModalOpen(true)}
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#96121D' }}
              >
                Télécharger le catalogue <Icon name="Download" size={16} className="ml-2" />
              </button>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center border border-white/20">
              <Icon name="Mail" size={32} className="mx-auto mb-4" style={{ color: '#9B8E57' }} />
              <h3 className="text-xl font-bold mb-2">Devis Personnalisé</h3>
              <p className="text-gray-300 mb-4">Recevez une proposition adaptée</p>
              <Link 
                to="/information-request-form"
                className="inline-flex items-center justify-center text-sm font-semibold hover:underline"
                style={{ color: '#9B8E57' }}
              >
                Demander un devis <Icon name="ArrowRight" size={16} className="ml-2" />
              </Link>
            </div>
          </div>

          <div className="text-center mb-16">
            <Link 
              to="/contact"
              className="inline-flex items-center justify-center px-12 py-5 text-xl font-semibold text-white rounded-lg transition-all duration-300 shadow-lg hover:shadow-2xl"
              style={{ 
                backgroundColor: '#96121D',
                boxShadow: '0 4px 14px rgba(150, 18, 29, 0.4)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#7d0f18';
                e.target.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#96121D';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              Commencer Ma Formation
              <Icon name="ArrowRight" size={24} className="ml-3" />
            </Link>
          </div>

          {/* Footer Complet */}
          <div className="border-t border-white/20 pt-12">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
              {/* Contact */}
              <div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#9B8E57' }}>CONTACT</h3>
                <div className="space-y-3">
                  <div className="flex items-start space-x-3">
                    <Icon name="Phone" size={20} className="flex-shrink-0 mt-1" style={{ color: '#9B8E57' }} />
                    <div>
                      <p className="text-gray-300">Téléphone</p>
                      <a href="tel:+12409784155" className="text-white hover:text-[#9B8E57] transition-colors">
                        +1 240-978-4155
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="Mail" size={20} className="flex-shrink-0 mt-1" style={{ color: '#9B8E57' }} />
                    <div>
                      <p className="text-gray-300">Email</p>
                      <a href="mailto:contact@crfperfection.pro" className="text-white hover:text-[#9B8E57] transition-colors">
                        contact@crfperfection.pro
                      </a>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <Icon name="MapPin" size={20} className="flex-shrink-0 mt-1" style={{ color: '#9B8E57' }} />
                    <div>
                      <p className="text-gray-300">Adresse</p>
                      <p className="text-white">1901 Pennsylvania Avenue NW<br />Washington D.C. 20006</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* À Propos */}
              <div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#9B8E57' }}>À PROPOS</h3>
                <p className="text-gray-300 leading-relaxed mb-4">
                  CRF Perfection est un cabinet international de formation, de conseil stratégique et de recherche appliquée, 
                  basé aux États-Unis, avec des agences en Afrique de l'Ouest (Bénin, Côte d'Ivoire, Togo).
                </p>
                <div className="flex items-center space-x-2">
                  <Icon name="Globe" size={20} style={{ color: '#96121D' }} />
                  <a href="https://www.crfperfection.pro" target="_blank" rel="noopener noreferrer" 
                     className="text-white hover:text-[#9B8E57] transition-colors">
                    www.crfperfection.pro
                  </a>
                </div>
              </div>

              {/* Nos Services */}
              <div>
                <h3 className="text-xl font-bold mb-4" style={{ color: '#9B8E57' }}>NOS SERVICES</h3>
                <ul className="space-y-2">
                  <li className="flex items-center space-x-2">
                    <Icon name="CheckCircle" size={16} style={{ color: '#96121D' }} />
                    <span className="text-gray-300">Formations professionnelles</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="CheckCircle" size={16} style={{ color: '#96121D' }} />
                    <span className="text-gray-300">Organisation de conférences</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="CheckCircle" size={16} style={{ color: '#96121D' }} />
                    <span className="text-gray-300">Conseil stratégique</span>
                  </li>
                  <li className="flex items-center space-x-2">
                    <Icon name="CheckCircle" size={16} style={{ color: '#96121D' }} />
                    <span className="text-gray-300">Études et recherches appliquées</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Copyright */}
            <div className="border-t border-white/20 pt-8 text-center">
              <p className="text-gray-400 mb-2">
                CRF Perfection – Cabinet International de Formation & Conseil
              </p>
              <p className="text-gray-500 text-sm">
                Bâtissons ensemble les compétences de demain.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <CatalogDownloadModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        catalogUrl={catalogUrl}
      />
    </div>
  );
};

export default ProfessionalTrainingServicesPage;